import { getAssets, swalError, swalSuccess } from "@unisearch/helpers";
import API from "@unisearch/helpers/api";
import { useAuthActions, useSystemActions } from "@_recoil/_actions";
import { authAtom } from "@_recoil/_state";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { ImSpinner8 } from "react-icons/im";
import { MdSwapCalls } from "react-icons/md";
import { useRecoilValue } from "recoil";
import styles from "./actions.module.scss";

export const CompareAction = ({
  referance,
  referanceId,
  is_compared,
  ...props
}) => {
  const router = useRouter();
  const profileInfo = useRecoilValue(authAtom);
  const systemActions = useSystemActions();
  const authActions = useAuthActions();
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    //remove redirect url
    systemActions.removeReturnUrl();
  }, []);

  //Handle University Compare
  const handleUniCompare = async (universityId) => {
    setIsLoading(true);
    if (profileInfo && profileInfo.userTypeSlug === "student") {
      if (
        profileInfo.compareUniversityList &&
        !profileInfo.compareUniversityList.includes(parseInt(universityId)) &&
        profileInfo.compareUniversityList.length >= 3
      ) {
        swalError(
          "You can compare among a maximum of 3 universities",
          "Sorry!"
        );
        setIsLoading(false);
        return false;
      }

      await API.post(`/student/compare-university`, { universityId }).then(
        async (resp) => {
          if (!resp.error && resp.data) {
            await authActions.getProfile();
            setIsLoading(false);
          } else {
            swalError(resp.error);
            setIsLoading(false);
          }
        }
      );
    } else if (profileInfo && profileInfo.userTypeSlug !== "student") {
      setIsLoading(false);
      return;
    } else {
      setIsLoading(false);
      systemActions.setReturnUrl(router.asPath);
      await router.push({ pathname: "/signin" });
    }
  };

  //course Compare
  const handleCourseCompare = async (courseId) => {
    setIsLoading(true);
    if (profileInfo && profileInfo.userTypeSlug === "student") {
      if (
        profileInfo.compareCourseList &&
        !profileInfo.compareCourseList.includes(parseInt(courseId)) &&
        profileInfo.compareCourseList.length >= 3
      ) {
        swalError("You can compare among a maximum of 3 courses", "Sorry!");
        setIsLoading(false);
        return false;
      }

      await API.post(`/student/compare-course`, { courseId }).then(
        async (resp) => {
          if (!resp.error && resp.data) {
            await authActions.getProfile();
            setIsLoading(false);
          } else {
            swalError(resp.error);
            setIsLoading(false);
          }
        }
      );
    } else if (profileInfo && profileInfo.userTypeSlug !== "student") {
      setIsLoading(false);

      return;
    } else {
      setIsLoading(false);

      systemActions.setReturnUrl(router.asPath);
      await router.push({ pathname: "/signin" });
    }
  };

  const renderComponent = () => {
    //for active
    if (is_compared == false) {
      if (referance && referance == "university" && referanceId != "") {
        return (
          <div className={`${styles.favourite_wrapper}  relative`}>
            {!isLoading && (
              <MdSwapCalls
                className={`${styles.icon_heart} ${styles.icon_swap}`}
                onClick={() => handleUniCompare(referanceId)}
              />
            )}
            {referanceId && isLoading && (
              <ImSpinner8 className={`${styles.icon_spin}`} />
            )}
            {!profileInfo ? (
              <div className={`uni-tooltip`}>
                Please Login <br /> to perform this action
              </div>
            ) : (
              <div className={`uni-tooltip`}>
                Add to <br /> compare
              </div>
            )}
          </div>
        );
      }

      if (referance && referance == "course" && referanceId != "") {
        return (
          <div className={`${styles.favourite_wrapper}  relative`}>
            {!isLoading && (
              <MdSwapCalls
                className={`${styles.icon_heart} ${styles.icon_swap}`}
                onClick={() => handleCourseCompare(referanceId)}
              />
            )}
            {referanceId && isLoading && (
              <ImSpinner8 className={`${styles.icon_spin}`} />
            )}
            {!profileInfo ? (
              <div className={`uni-tooltip`}>
                Please Login <br /> to perform this action
              </div>
            ) : (
              <div className={`uni-tooltip`}>
                Add to <br /> compare
              </div>
            )}
          </div>
        );
      }
    }

    //for inactive
    if (is_compared == true) {
      if (referance && referance == "university" && referanceId != "") {
        return (
          <div className={`${styles.favourite_wrapper}  relative`}>
            {!isLoading && (
              <MdSwapCalls
                className={`${styles.icon_heart} ${styles.icon_swap} ${styles.selected}`}
                onClick={() => handleUniCompare(referanceId)}
              />
            )}
            {referanceId && isLoading && (
              <ImSpinner8 className={`${styles.icon_spin}`} />
            )}
            <div className={`uni-tooltip`}>
              Remove from <br /> compare
            </div>
          </div>
        );
      }
      if (referance && referance == "course" && referanceId != "") {
        return (
          <div className={`${styles.favourite_wrapper}  relative`}>
            {!isLoading && (
              <MdSwapCalls
                className={`${styles.icon_heart} ${styles.icon_swap} ${styles.selected}`}
                onClick={() => handleCourseCompare(referanceId)}
              />
            )}
            {referanceId && isLoading && (
              <ImSpinner8 className={`${styles.icon_spin}`} />
            )}
            <div className={`uni-tooltip`}>
              Remove from <br /> compare
            </div>
          </div>
        );
      }
    }
  };

  if (typeof window !== "undefined") {
    return renderComponent();
  } else {
    return false;
  }
};

export default CompareAction;
